/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Qc_Fix_Uncorrected_ToastInputs */

const en_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} event(s) could not be corrected automatically`)
};

const fr_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} événement(s) n'ont pas pu être corrigés automatiquement`)
};

const de_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Event(s) konnten nicht automatisch korrigiert werden`)
};

const it_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventi non sono stati corretti automaticamente`)
};

const ru_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} событий не удалось исправить автоматически`)
};

const es_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} evento(s) no se pudieron corregir automáticamente`)
};

const zh_cn2_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个事件无法自动修复`)
};

const ja_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}件のイベントを自動修正できませんでした`)
};

const hi_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} इवेंट स्वचालित रूप से ठीक नहीं किए जा सके`)
};

const pt_pt2_qc_fix_uncorrected_toast = /** @type {(inputs: Qc_Fix_Uncorrected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} evento(s) não puderam ser corrigidos automaticamente`)
};

/**
* | output |
* | --- |
* | "{count} event(s) could not be corrected automatically" |
*
* @param {Qc_Fix_Uncorrected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_uncorrected_toast = /** @type {((inputs: Qc_Fix_Uncorrected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Uncorrected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_qc_fix_uncorrected_toast(inputs)
	if (locale === "de") return de_qc_fix_uncorrected_toast(inputs)
	if (locale === "it") return it_qc_fix_uncorrected_toast(inputs)
	if (locale === "ru") return ru_qc_fix_uncorrected_toast(inputs)
	if (locale === "es") return es_qc_fix_uncorrected_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_qc_fix_uncorrected_toast(inputs)
	if (locale === "ja") return ja_qc_fix_uncorrected_toast(inputs)
	if (locale === "hi") return hi_qc_fix_uncorrected_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_qc_fix_uncorrected_toast(inputs)
	return en_qc_fix_uncorrected_toast(inputs)
});